function makeDecimalPoints(value) {
    try {
        value = value.toFixed(2);
    } catch (error) {
        value = 0;
    }
    return value;
}
  
export default makeDecimalPoints;